import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "../../../Translation";
import { ArrowRightStartOnRectangleIcon, Cog8ToothIcon, DocumentIcon, ExclamationCircleIcon, TagIcon } from "@heroicons/react/24/outline";
import { TextArea } from "../../Inputs/TextArea";
import { Button } from "../../Buttons";
import Tabs, { useTabs } from "../../Tabs";
import { useAPI } from "../../../API";
import Select from "../../Inputs/Select";
import { bgColor, hoverBgColor, textColor } from "../../../Resources/CSS/styling";
import Radio from "../../Inputs/Radio";


const ConfigurationTab = ({ tmpStep, setTmpStep, save, error, isCreate, allSteps = [] }) => {

    const { translate } = useTranslation();
    const api = useAPI();


    const setSelectedStep = (selectedStep) => {
        console.log(selectedStep);
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, go_to_next_step_id: selectedStep.id } });
    }

    const selectedStep = allSteps.length > 0 ? allSteps.find((step) => step.id === parseInt(tmpStep.data.go_to_next_step_id)) || allSteps[0] : null;


    useEffect(() => {
        if (tmpStep && tmpStep.data && !tmpStep.data.go_to_next_step_id && allSteps.length > 0) {
            setTmpStep({ ...tmpStep, data: { ...tmpStep.data, go_to_next_step_id: allSteps[0].id } });
        }
    }, [tmpStep, allSteps])
  
    return (
        <div className="flex flex-col mt-4 overflow-visible">

            {error && <p className="text-red-600 flex flex-row items-center bg-red-50 p-4"><ExclamationCircleIcon className="w-6 h-6 mr-2" />{error}</p>}
            <p className="text-xl text-gray-600 font-bold mt-2">{translate('automatisation.action')}</p>
             
            <p className="text-xl text-gray-600 font-bold mt-2">{translate('automatisation.step_to_jump_to')}</p>
            {allSteps.length > 0 && <Select selected={selectedStep} options={allSteps} setSelected={(e) => setSelectedStep(e)} />}   

            {!isCreate && <div className="flex flex-row w-full flex-1 justify-end mt-4">
                <div className="flex flex-row">
                    <Button className="bg-black hover:bg-gray-800" onClick={() => save(tmpStep)}>
                        {translate('save')}
                    </Button>
                </div>
            </div>}
        </div>
    )
}

const DescriptionTab = ({ tmpStep, setTmpStep, save, isCreate }) => {
    const { translate } = useTranslation();
    return (
        <div className="flex flex-col mt-4">
            <p className="text-xl text-gray-600 font-bold">{translate('automatisation.description')}</p>
            <TextArea rows={5} value={tmpStep.description} onChange={(e) => setTmpStep({ ...tmpStep, description: e.target.value })} />

            {!isCreate && <div className="flex flex-row w-full flex-1 justify-end mt-4">
                <div className="flex flex-row">
                    <Button className="bg-black hover:bg-gray-800" onClick={() => save(tmpStep, JSON.stringify(tmpStep.data.body))}>
                        {translate('save')}
                    </Button>
                </div>
            </div>}
        </div>
    )
}

export default function GoToPanel({ automatisationId, setStepToClone, panelHook, step, refresh, deleteStep, isCreate, onCreateNewStep }) {
    const { translate } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    const [tmpStep, setTmpStep] = useState({ ...step });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const api = useAPI();

    const tabs = useTabs([
        { icon: Cog8ToothIcon, name: translate('automatisation.configuration'), current: true },
        { icon: DocumentIcon, name: translate('automatisation.description'), current: false }
    ]);

    const [allSteps, setAllSteps] = useState([]);

    useEffect(() => {
        api.fetchAutomatisationSteps(automatisationId).then(responseSteps => {
            setAllSteps(responseSteps.data.automatisation_steps.map(x => {
                return {
                    ...x,
                    name: x.type + ` - (${x.description})`
                }
            }));
        });
        
    }, [automatisationId]);
    
    
    // Reset tmpStep when panel is closed
    useEffect(() => {
        if (!panelHook.open) {
            setTmpStep({ ...step });
        }
    }, [panelHook.open]);

    const save = async (tmpStep) => {


        try {
            if (isCreate) {
                if (!tmpStep.description || tmpStep.description.trim() === '') {
                    tmpStep.description = "Go To event ";
                }

                const newStepResponse = await api.createAutomatisationStep(tmpStep.automatisation_id, tmpStep);
                if (newStepResponse.data.automatisation_step) {
                    onCreateNewStep(newStepResponse.data.automatisation_step);
                }
            } else {
                await api.updateAutomatisationStep(tmpStep.automatisation_id, tmpStep);
            }

            panelHook.setOpen(false);
            setTimeout(() => {
                refresh();
            }, 1000);
        } catch (e) {
            setError('Invalid JSON');
            return;
        }

    }

    const selectStepToClone = (step) => {
        setStepToClone(step);
        panelHook.setOpen(false);
    }

    return (
        <div className="flex flex-col flex-1 rounded-md p-4 overflow-hidden h-full w-96">
            <div className="flex flex-row items-center">
                <ArrowRightStartOnRectangleIcon className={`w-12 h-12 min-w-12 min-h-12 aspect-square border p-2 bg-gray-50 rounded-md mr-2 ${textColor}`} />
                <div className="flex flex-col ml-2">
                    <h2 className="text-xl font-bold">{translate('automatisation.go_to')}</h2>
                </div>
                
                <div className="flex flex-row flex-1 justify-end">

                {!isCreate && <Button className="bg-red-600 hover:bg-red-300 ml-4" onClick={deleteStep}>
                        {translate('delete')}
                    </Button>}
                {isCreate && <Button className={`${bgColor} ${hoverBgColor} ml-4 opacity-100`} onClick={() => save(tmpStep)}>{translate('create')}</Button>}
                {!isCreate && <Button className={`${bgColor} ${hoverBgColor} ml-4 opacity-100`} onClick={() => selectStepToClone(tmpStep)}>{translate('clone')}</Button>}
                </div>
            </div>

            <div className="flex flex-row overflow-x-scroll no-scrollbar">
                <Tabs tabs={tabs} />
            </div>

            {tabs.currentTabIndex === 0 && <ConfigurationTab tmpStep={tmpStep} setTmpStep={setTmpStep} panelHook={panelHook} error={error} save={save} isCreate={isCreate} allSteps={allSteps} />}
            {tabs.currentTabIndex === 1 && <DescriptionTab tmpStep={tmpStep} setTmpStep={setTmpStep} panelHook={panelHook} error={error} save={save} isCreate={isCreate} />}
        </div>
    )
}